// extracted by mini-css-extract-plugin
export default {"cls1":"RemovedItemNotice-cls1__bfa9c1b14146df5a677d","cls2":"RemovedItemNotice-cls2___af6b2950337712c7122 RemovedItemNotice-cls1__bfa9c1b14146df5a677d"};